/**
 * Convert string into pascal case.
 * @memberof module:stringcase/lib
 * @function pascalcase
 * @param {string} str - String to convert.
 * @returns {string} Pascal case string.
 */
'use strict';

var camelcase = require('./camelcase');

var capitalcase = require('./capitalcase');
/** @lends pascalcase */


function pascalcase(str) {
  return capitalcase(camelcase(str));
}

module.exports = pascalcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBhc2NhbGNhc2UuanMiXSwibmFtZXMiOlsiY2FtZWxjYXNlIiwicmVxdWlyZSIsImNhcGl0YWxjYXNlIiwicGFzY2FsY2FzZSIsInN0ciIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0FBUUE7O0FBRUEsSUFBTUEsU0FBUyxHQUFHQyxPQUFPLENBQUMsYUFBRCxDQUF6Qjs7QUFDQSxJQUFNQyxXQUFXLEdBQUdELE9BQU8sQ0FBQyxlQUFELENBQTNCO0FBRUE7OztBQUNBLFNBQVNFLFVBQVQsQ0FBcUJDLEdBQXJCLEVBQTBCO0FBQ3hCLFNBQU9GLFdBQVcsQ0FBQ0YsU0FBUyxDQUFDSSxHQUFELENBQVYsQ0FBbEI7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCSCxVQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gcGFzY2FsIGNhc2UuXG4gKiBAbWVtYmVyb2YgbW9kdWxlOnN0cmluZ2Nhc2UvbGliXG4gKiBAZnVuY3Rpb24gcGFzY2FsY2FzZVxuICogQHBhcmFtIHtzdHJpbmd9IHN0ciAtIFN0cmluZyB0byBjb252ZXJ0LlxuICogQHJldHVybnMge3N0cmluZ30gUGFzY2FsIGNhc2Ugc3RyaW5nLlxuICovXG5cbid1c2Ugc3RyaWN0J1xuXG5jb25zdCBjYW1lbGNhc2UgPSByZXF1aXJlKCcuL2NhbWVsY2FzZScpXG5jb25zdCBjYXBpdGFsY2FzZSA9IHJlcXVpcmUoJy4vY2FwaXRhbGNhc2UnKVxuXG4vKiogQGxlbmRzIHBhc2NhbGNhc2UgKi9cbmZ1bmN0aW9uIHBhc2NhbGNhc2UgKHN0cikge1xuICByZXR1cm4gY2FwaXRhbGNhc2UoY2FtZWxjYXNlKHN0cikpXG59XG5cbm1vZHVsZS5leHBvcnRzID0gcGFzY2FsY2FzZSJdfQ==